import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminVenueApplications = lazy(() => import("@/pages/admin/AdminVenueApplications"));

export const Route = createFileRoute("/admin/venue-applications")({
  component: AdminVenueApplications,
});
